<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-3/4 h-3/4 mx-auto bg-white border rounded-lg"
  >
    <div ref="tpl">
      <div class="p-6 standard-form">
        <div class="pb-4 text-xl text-center">Country Setup for {{ country.name }}</div>
        <div class="standard-field-wrapper pb-1">
          <label for="iso_country_code">ISO Country Code</label>
          <div class="standard-input-wrapper w-24">
            <div class="standard-input-container">
              <input class=" w-48" type="text" name="iso_country_code" v-model="country.silo_details.iso_country_code">
            </div>
          </div>
        </div>
        <div class="standard-field-wrapper pb-1">
          <label for="achieve_active">Achieve Active</label>
          <div class="standard-input-wrapper w-24">
            <div class="standard-input-container">
              <input class=" w-48" type="checkbox" name="achieve_active" v-model="country.silo_details.achieve_active">
            </div>
          </div>
        </div>
        <div class="standard-field-wrapper py-1">
          <label for="fourthLevel">Has Fourth Level</label>
          <div class="standard-input-wrapper">
            <div class="standard-input-container">
              <input type="checkbox" id="has-fourth-level" v-model="hasFourthLevel">
            </div>
          </div>
        </div>

        <div class="standard-field-wrapper py-1" v-show = "hasFourthLevel">
          <label for="fourthLevel">Early Load Level 4</label>
          <div class="standard-input-wrapper">
            <div class="standard-input-container">
              <input type="checkbox" id="early-level-4" v-model="earlyLevel4">
            </div>
          </div>
        </div>

        <div class="pb-4 text-xl text-center">Set prompts for each Admin Level</div>
        <div :key="index" v-for="(item, index) in country.silo_details.levels" >
          <div class="standard-field-wrapper py-1">
            <label>Admin Level {{item.admin_level}}</label>
            <div class="standard-input-wrapper">
              <div class="standard-input-container w-64">
                <input type="text" :name="'label_' + index" v-model="item.label">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-row justify-end mt-4 p-6">
        <button class="btn btn-primary mr-2" @click="updateCountry()">Update</button>
        <button class="btn btn-secondary" @click="closeModal()">Cancel</button>
      </div>
    </div>
  </VueFinalModal>
</template>

<script setup>
  import { VueFinalModal } from 'vue-final-modal'
  import { onMounted, ref, watch } from 'vue'
  import axios from 'axios'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['personToAssociate'])

  let country = ref({})
  let hasFourthLevel = ref(true)
  let earlyLevel4 = ref(false)
  let loaded = ref(false)
  let date = ref(null)

  onMounted(() => {
    country.value = props.params.data.country

    if (!country.value.silo_details || Object.keys(country.value.silo_details).length === 0) {
      country.value.silo_details = siloDefaults()

      if (country.value.remote_data && country.value.iso3_code) {
        country.value.silo_details.iso_country_code = country.value.iso3_code
      }
    }

    hasFourthLevel.value = country.value.silo_details.has_fourth_level
    earlyLevel4.value = hasFourthLevel.value && Array.isArray(country.value.silo_details.levels[3].part_of)
    
    console.log(country.value)

    let today = new Date()
    date.value = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
    loaded.value = true
  })

  watch(earlyLevel4, (newVal, oldVal) => {
    if (hasFourthLevel.value) {
      if (newVal) {
        country.value.silo_details.levels[3].part_of = ['admin3', 'admin2']
      } else {
        country.value.silo_details.levels[3].part_of = 'admin3'
      }
    }
  })

  watch(hasFourthLevel, (newVal, oldVal) => {
    if (newVal && country.value.silo_details.levels.length < 4) {
      let newLevel = { label: 'Level 3', name: 'admin3', part_of: 'admin2', admin_level: "3" }
      country.value.silo_details.levels.splice(2, 0, newLevel)
      country.value.silo_details.levels.part_of = earlyLevel4.value ? ['admin3', 'admin2'] : 'admin3'
    } else if (!newVal && country.value.silo_details.levels.length == 4) {
      country.value.silo_details.levels.splice(2, 1)
      country.value.silo_details.levels[2].part_of = 'admin2'
    }
    
    country.value.silo_details.has_fourth_level = newVal
  })


  function siloDefaults() {
    let dflt = {
      achieve_active: false,
      has_fourth_level: true,
      iso_country_code: '',
      levels: [
        { name: 'admin1', label: 'Level 1', part_of: '', admin_level: 1 },
        { name: 'admin2', label: 'Level 2', part_of: 'admin1', admin_level: 2 },
        { name: 'admin3', label: 'Level 3', part_of: 'admin2', admin_level: 3 },
        { name: 'admin4', label: 'Level 4', part_of: ['admin3','admin2'], admin_level: 4 },
      ]
    }

    return dflt
  }

  function closeModal () {
    emit('close')
  }

  async function updateCountry () {
    try {
      console.log(country.value.silo_details)
      await axios.put(`/countries/${country.value.id}.json`, {
        silo_details: country.value.silo_details,
        silo_updated_at: date.value,
        return_path: `/countries/${country.value.id}`,
      })
    } catch (err) {
      window.Rollbar.error('Failed to update Country',  err )
      alert('Unable to update Country')

    }
    finally {
      closeModal()
    }
  }
</script>

<style>
  .vm--modal {
    overflow: initial !important;
  }

  .bold {
    font-weight: bold;
  }

  .pad {
    margin: 5px;
  }
</style>
